export default __webpack_public_path__ + "static/media/P470_C_BD.4ef29df5.pdf";